















































import { Vue, Component, Ref } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { Dependente } from '@/models'
import DatePickerAniversario from '../ui/DatePickerAniversario.vue'
import { obrigatorio } from '@/shareds/regras-de-form'

@Component({
	components: {
		DatePickerAniversario,
	},
})
export default class DialogoDeEdicaoDependente extends Vue {
	@Ref() form!: HTMLFormElement
	dependente: Dependente | null = null
	mostra = false
	salvando = false

	obrigatorio = obrigatorio
	generos = ['MASCULINO', 'FEMININO', 'OUTROS']

	mostrar(dependenteAtual: Dependente) {
		const dependenteObj = new Object() as Dependente

		dependenteObj.id = dependenteAtual.id
		dependenteObj.nome = dependenteAtual.nome
		dependenteObj.dataNascimento = dependenteAtual.dataNascimento
		dependenteObj.genero = dependenteAtual.genero

		this.dependente = dependenteObj
		this.mostra = true
	}

	esconder() {
		this.mostra = false
		this.dependente = null
	}

	salvar() {
		if (!this.dependente) return
		if (!this.form.validate()) return

		try {
			this.salvando = true

			this.$emit('atualizar', this.dependente)

		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.mostra = false
			this.salvando = false
			this.dependente = null
		}
	}
}
